import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpFilterTable
     * @memberof app
     *
     * @restrict A
     * @scope {}
     *
     * @description
     * This directive is required by the {@link pkpColumnFilter} directive to collect information relevant
     * to every individual column filter like knowing which table to filter, what function to call when the filter
     * changes and what the current filter options are.
     *
     * @param {string} pkpFilterTable The table name to filter from {@link app.COLUMN_FILTER#COL}.
     * @param {Object} pkpCurrentFilter The currently active column filters.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpFilterTable', pkpFilterTable);

    function pkpFilterTable() {
        return {
            restrict: 'A',
            scope: {
                pkpFilterTable: '=',
                pkpCurrentFilter: '='
            },
            controller: CurrentFilterCtrl
        };

        function CurrentFilterCtrl($scope, $element) {
            var vm = this;

            vm.filterTable = $scope.pkpFilterTable;
            vm.currentFilter = $scope.pkpCurrentFilter;

            $element.addClass('column-filter');
        }
    }
})();
